import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { institution } from "../userFormModal/types.props";
import type { parsedApiError } from "@/types/api/errors.api";
import type { institutionFormData } from "../institutionFormModal/types.props";
import type { useInstitutionModalProps } from "./types.props";

export const useInstitutionModal = ({
    create,
    update,
    remove,
    refreshStats,
}: useInstitutionModalProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingInstitution, setEditingInstitution] =
        useState<institution | null>(null);
    const [apiError, setApiError] = useState<parsedApiError | null>(null);
    const navigate = useNavigate();

    const handleOpenModal = (institution: institution | null = null) => {
        setEditingInstitution(institution);
        setApiError(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingInstitution(null);
        setApiError(null);
    };

    const handleSubmit = async (formData: institutionFormData) => {
        setApiError(null);
        try {
            if (editingInstitution) {
                await update(editingInstitution.id, formData);
            } else {
                await create(formData);
            }
            await refreshStats();
            handleCloseModal();
        } catch (error) {
            setApiError(error as parsedApiError);
        }
    };

    const handleDeleteInstitution = async (inst: institution) => {
        if (
            window.confirm(
                `¿Está seguro de que desea eliminar la institución "${inst.name}"? Esta acción no se puede deshacer.`,
            )
        ) {
            setApiError(null);
            try {
                await remove(inst.id);
                await refreshStats();
            } catch (error) {
                setApiError(error as parsedApiError);
            }
        }
    };

    const handleViewDashboard = (inst: institution) => {
        navigate(`/coordinator-dashboard?institutionId=${inst.id}`);
    };

    return {
        isModalOpen,
        editingInstitution,
        apiError,
        handleOpenModal,
        handleCloseModal,
        handleSubmit,
        handleViewDashboard,
        handleDeleteInstitution,
    };
};
